"use client"
import clsx from "clsx"
import { HeaderVariant, menuIconColor } from "./constants"

interface MenuIconProps {
  variant: HeaderVariant
  isScrolled: boolean
  openMenu: () => void
}

export const MenuIcon = ({ variant, isScrolled, openMenu }: MenuIconProps) => (
  <div
    onClick={openMenu}
    className={clsx(
      "xl:hidden flex flex-col gap-[5px] cursor-pointer justify-center",
      isScrolled && "scale-85 origin-right"
    )}
  >
    <span className={clsx("block w-6 h-[1px]", menuIconColor[variant])}></span>
    <span className={clsx("block w-6 h-[1px]", menuIconColor[variant])}></span>
    <span className={clsx("block w-6 h-[1px]", menuIconColor[variant])}></span>
  </div>
)
